import buildInfo from '../generated/build-info.json';

export const openedBuild = buildInfo;

export function formatReleaseDate(value) {
  if (!value || Number.isNaN(Date.parse(value))) return 'Nicht erfasst';
  return new Intl.DateTimeFormat('de-AT', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Europe/Vienna' }).format(new Date(value));
}

export function isSameBuild(first, second) {
  return Boolean(first?.buildId && second?.buildId && first.buildId === second.buildId);
}

export function releaseMatches(release, query) {
  return [release.version, release.title, release.commit, release.buildId, release.branch,
    ...Object.values(release.notes || {}).flat()].filter(Boolean).join(' ').toLowerCase().includes(query.trim().toLowerCase());
}

export async function fetchHostedBuild() {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch(`${process.env.PUBLIC_URL || ''}/version.json`, { cache: 'no-store', signal: controller.signal });
    if (!response.ok) throw new Error('Version konnte nicht geladen werden');
    const data = await response.json();
    if (data.schemaVersion !== 1 || !data.buildId) throw new Error('Ungültige Versionsdaten');
    return data;
  } finally { clearTimeout(timeout); }
}
